/**
 * Animations
 */
export const animations = () => {

	const animationsElements = document.querySelectorAll( '.animation' );

	const observer = new IntersectionObserver( entries => {

		entries.forEach( entry => {

			if ( entry.isIntersecting ) {

				entry.target.classList.add( 'animation--done' );

			}

		} );

	} );

	animationsElements.forEach( sections => {

		observer.observe( sections );

	} );

}
